import script from "./HeaderBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderBar.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace});
